import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    ViewChild,
    computed,
    input,
    output,
} from '@angular/core'
import type {
    BookingSlotAreaGroup,
    BookingSlotChoice,
} from '../../../domain/Availability'
import { VenueStorefrontBookingAreaSlotsComponent } from '../venue-storefront-booking-area-slots/venue-storefront-booking-area-slots.component'

@Component({
    selector: 'app-venue-storefront-booking-slot-step',
    standalone: true,
    imports: [VenueStorefrontBookingAreaSlotsComponent],
    templateUrl: './venue-storefront-booking-slot-step.component.html',
    styleUrls: ['./venue-storefront-booking-slot-step.component.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VenueStorefrontBookingSlotStepComponent implements AfterViewInit {
    groups = input.required<BookingSlotAreaGroup[]>()
    idealTime = input.required<Date>()
    selectedSlot = input<BookingSlotChoice | null>(null)
    slotSelected = output<BookingSlotChoice>()
    waitlistSlotSelected = output<BookingSlotChoice>()
    joinWaitlistRequested = output<void>()
    protected readonly customerChoosesArea = computed(() => {
        return this.groups().some(group => group.area !== null)
    })
    @ViewChild('heading', { static: true }) private heading!: ElementRef<HTMLHeadingElement>

    ngAfterViewInit() {
        this.heading.nativeElement.focus({ preventScroll: true })
    }
}
